import React from 'react';

const News = () => {
  return (
    <>
    
      <h1>News section</h1>
    </>
  )
};

export default News;